import * as EventListener from "../../../common/helpers/event-listener";
import csrfToken from "../../../common/helpers/csrf-token";

const changeSenderType = () => {
    EventListener.change("order-type", (radio) => {
        document.querySelectorAll(".order-type").forEach((element) => {
            element.disabled = true;
        });
        document.getElementById("senderFormButton").disabled = true;

        const partial = radio.getAttribute("data-partial");

        if (partial === "natural-person-form") {
            const wrapper = document.querySelector(".sender-form-wrapper");

            if (wrapper) {
                wrapper.innerHTML = "";
            }

            document.querySelectorAll(".order-type").forEach((element) => {
                element.disabled = false;
            });
            document.getElementById("senderFormButton").disabled = false;

            return;
        }

        oc.ajax("Settings::onAjax", {
            data: { _token: csrfToken },
            update: {
                [`catalog/cart/sender-form/${partial}`]: ".sender-form-wrapper",
            },
            complete: () => {
                document.querySelectorAll(".order-type").forEach((element) => {
                    element.disabled = false;
                });
                document.getElementById("senderFormButton").disabled = false;
            },
        });
    });
};

const createAccount = () => {
    EventListener.change("new-account", (element) => {
        document.getElementById("senderFormButton").disabled = true;
        const state = element.getAttribute("data-state");

        if (state !== "on") {
            oc.ajax("Settings::onAjax", {
                data: { _token: csrfToken },
                update: {
                    "catalog/cart/sender-form/password-form":
                        ".order-new-account-block",
                },
                complete: () => {
                    element.disabled = false;
                    document.getElementById("senderFormButton").disabled =
                        false;
                },
            });
            element.setAttribute("data-state", "on");
        } else {
            document.querySelector(".order-new-account-block").textContent =
                null;
            element.setAttribute("data-state", "off");
            element.disabled = false;
            document.getElementById("senderFormButton").disabled = false;
        }
    });
};

const changeSenderCountry = () => {
    EventListener.change("change-sender-country-select", (select) => {
        oc.ajax("onInit", {
            data: {
                _token: csrfToken,
                country_id: select.value,
            },
            loading: "#loader-line",
            update: {
                "catalog/cart/sender-form/sender-district-locality":
                    ".sender-district-locality-wrapper",
            },
            complete: () => {
                select.disabled = false;
            },
        });
    });
};

const changeSenderDistrict = () => {
    EventListener.change("change-sender-district-select", (select) => {
        oc.ajax("Settings::onAjax", {
            data: {
                _token: csrfToken,
                district_id: select.value,
            },
            loading: "#loader-line",
            update: {
                "catalog/cart/sender-form/sender-locality":
                    ".sender-locality-wrapper",
            },
            complete: () => {
                select.disabled = false;
            },
        });
    });
};

const saveSenderData = () => {
    EventListener.submit(
        "saveSenderDataForm",
        null,
        "saveSenderDataFormError",
        (formData, button, formError, formMessage) => {
            document.getElementById("saveSenderDataFormError").textContent =
                null;
            oc.ajax("Cart::onSaveSenderData", {
                loading: "#loader-line",
                data: {
                    _token: csrfToken,
                    sender_type: formData.get("sender_type"),
                    first_name: formData.get("first_name"),
                    last_name: formData.get("last_name"),
                    email: formData.get("email"),
                    phone: formData.get("phone"),
                    uic: formData.get("uic"),
                    trade_register: formData.get("trade_register"),
                    company_name: formData.get("company_name"),
                    address: formData.get("address"),
                    iban: formData.get("iban"),
                    country_id: formData.get("country_id"),
                    locality_id: formData.get("locality_id"),
                    locality_name: formData.get("locality_name"),
                    district_name: formData.get("district_name"),
                    district_id: formData.get("district_id"),
                    operator_id: formData.get("operator_id"),
                    is_create_account: formData.get("is_create_account"),
                    password: formData.get("password"),
                    password_confirmation: formData.get(
                        "password_confirmation",
                    ),
                    is_sms_confirmation: formData.get("is_sms_confirmation"),
                    payment_method_id: formData.get("payment_method_id"),
                },
                complete: (result) => {
                    if (!result.status && result.message) {
                        formMessage.textContent = result.message;
                    }

                    button.disabled = false;
                },
            });
        },
    );
};

changeSenderType();
createAccount();
changeSenderCountry();
changeSenderDistrict();
saveSenderData();
